import _repeatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/repeat";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
import { v4 as uuidv4 } from "uuid";
export default defineComponent({
  name: "MaskedInput",
  props: {
    value: {
      type: null,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    colSize: {
      type: String,
      default: "4"
    },
    maxlength: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    mask: {
      type: [String, Object],
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    inputClass: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    inputContainerClass: {
      type: String,
      default: ""
    },
    wrapperClass: {
      type: String,
      default: ""
    },
    formatType: {
      type: String,
      default: ""
    },
    decimals: {
      type: Number,
      default: 3
    }
  },
  data() {
    return {
      labelValue: uuidv4()
    };
  },
  computed: {
    inputMask() {
      const maskParser = {
        money: {
          alias: "currency",
          rightAlign: false,
          prefix: "$",
          showMaskOnHover: false,
          allowMinus: false,
          allowPlus: false,
          autoUnmask: false
        },
        percentage: {
          alias: "percentage",
          max: 99999,
          greedy: false,
          autoUnmask: false,
          showMaskOnHover: false
        },
        numeric: {
          alias: "numeric",
          greedy: false,
          autoUnmask: false,
          rightAlign: false,
          showMaskOnHover: false
        }
      };
      return maskParser[this.formatType] || this.mask;
    },
    decimalMask() {
      var _context;
      return `9{1,}.${_repeatInstanceProperty(_context = "9").call(_context, this.decimals)}`;
    },
    decimalPlaceholder() {
      var _context2;
      return `0.${_repeatInstanceProperty(_context2 = "0").call(_context2, this.decimals)}`;
    },
    innerValue: {
      get() {
        return this.value;
      },
      set(value) {
        if (this.formatType === "money" && this.$refs.rawMaskInput.inputmask.unmaskedvalue() === "0.00") {
          this.$emit("input", null);
        } else this.$emit("input", value);
      }
    }
  },
  methods: {
    maskValue(value) {
      var _this$$refs$rawMaskIn;
      return (_this$$refs$rawMaskIn = this.$refs.rawMaskInput.inputmask.format(value, this.inputMask)) == null ? void 0 : _this$$refs$rawMaskIn.value;
    },
    unmaskedValue() {
      if (this.$refs.rawMaskInput.inputmask.unmaskedvalue() === "0.00" && this.formatType === "money") {
        return null;
      } else return this.$refs.rawMaskInput.inputmask.unmaskedvalue();
    }
  }
});